import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"
import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7krHkBLWLIrvQR-S84DNNwOKIBR9IM7gsdwQBBlpOLmHhAOiy6Bbso7kd8Bm629oWEYA&usqp=CAU'
function ANTALYA() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>Antalya Science University</HighlightedText></>}
        description="Founded in 2010, Antalya Bilim University (ABU) is a private university located in Antalya, Turkey. It is known for its international focus, modern education system, and strong emphasis on entrepreneurship and innovation.

        "
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
            <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
    

      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>aysu çelikbaş   </td>
                <td>computer engineering</td>
                <td>2024</td>
                <td>8042</td>
                <td>FRC</td>
            </tr>
           
        </tbody>
    </table>
</div>



    
                
            

          
</TwoColumn>
</Container>
<Footer />
        </ AnimationRevealPage>
  )
}

export default ANTALYA